import React from "react";
import { FC, useCallback } from "react";
import { AgoraVideoPlayer, IAgoraRTCRemoteUser } from "agora-rtc-react";
import Avatar from "@components/profile/avatar";

interface IUserVideoProps
{
    user: IAgoraRTCRemoteUser
}

const UserVideo: FC<IUserVideoProps> = (props) => {
    const { user } = props;

    const getUsername = useCallback(() => {
        if(!user) return "Unknown user";

        return user.uid.toString() || "Unknown user";
        // Get username from API
    }, [user]);

    return (
        <>
            {
                user.videoTrack ?
                <AgoraVideoPlayer
                    className=""
                    videoTrack={user.videoTrack}
                    style={{ borderRadius: '0px', width: '100%', height: '100%' }}
                    key={user.uid}
                />
                : 
                <div className="Avatar">
                    <Avatar 
                        username={String(user.uid) ?? ''}
                        roleCode="PR"
                        size={30}
                        editable={false}
                    />
                </div>
            }
            <div className="VideoCall__MiniInfoName">
                <em className="fas fa-user" />
                <p className="VideoCall__MiniInfoNameText"> {getUsername()} </p>
            </div>
        </>
    );
}

export default UserVideo;
